/**
 * 類似検索 API の型定義
 */

/**
 * バリデーション定数（サーバーサイドと同期）
 */
export const VALIDATION = {
  MIN_QUERY_LENGTH: 10,
  MAX_QUERY_LENGTH: 1000
} as const;

/**
 * 類似検索リクエスト
 */
export interface SimilarSearchRequest {
  query: string;
}

/**
 * 検索結果の個別アイテム
 */
export interface SimilarSearchResult {
  topicId: number;
  title: string;
  snippet: string;
  url: string;
  score: number;
  targetAge?: string;
  targetGender?: string;
}

/**
 * 類似検索 API レスポンス
 */
export interface SimilarSearchResponse {
  results: SimilarSearchResult[];
}

/**
 * 類似検索ダイアログの Props
 */
export interface SimilarSearchDialogProps {
  visible: boolean;
  onClose: () => void;
}
